import { Mail, X } from '@/components/ui/icons';
import { useState } from 'react';
import { errorMessage } from '@/api/client';
import { authApi } from '@/api/endpoints';
import { useAuth } from '@/stores/auth';
import { toast } from '@/stores/ui';

/** When confirming your email is optional: a gentle reminder at the top of the app. */
export function EmailReminder() {
  const show = useAuth((s) => s.config.emailVerification === 'optional' && s.user?.emailVerified === false);
  const email = useAuth((s) => s.user?.email);
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  if (!show || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await authApi.resendVerification();
      toast.success(`Sent! Check ${email}.`);
      setDismissed(true);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div role="status" className="flex shrink-0 items-center gap-3 bg-accent-2-soft px-4 py-2 text-sm text-accent-2-ink">
      <Mail size={16} className="shrink-0" />
      <p className="min-w-0 flex-1">
        Please confirm your email so you can reset your password if you ever forget it.{' '}
        <button type="button" disabled={sending} onClick={() => void resend()} className="font-semibold underline disabled:opacity-60">
          Send the link again
        </button>
      </p>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss" className="rounded-full p-1 hover:bg-hover">
        <X size={15} />
      </button>
    </div>
  );
}
